module.exports = __webpack_public_path__ + "img/bg_map_02.6d734b51.jpg";